export enum SegmentOptions {
  AllActive = 'allActive',
  Conditional = 'conditional',
  CustomList = 'customList',
}
